<template>
  <el-dialog
    :model-value="visible"
    title="编辑素材"
    width="480px"
    :close-on-click-modal="false"
    @update:model-value="$emit('update:visible', $event)"
  >
    <el-form :model="form" label-width="80px" v-if="asset">
      <el-form-item label="名称" required>
        <el-input v-model="form.name" placeholder="素材名称" maxlength="200" />
      </el-form-item>
      <el-form-item label="描述">
        <el-input v-model="form.description" type="textarea" :rows="3" placeholder="简要描述" maxlength="1000" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="form.status" class="!w-32">
          <el-option label="正常" value="NORMAL" />
          <el-option label="禁用" value="DISABLED" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" :disabled="!form.name" :loading="submitting" @click="handleSubmit">保存</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { updateAsset } from '@/api/assets'

const props = defineProps({
  visible: { type: Boolean, default: false },
  asset: { type: Object, default: null }
})

const emit = defineEmits(['update:visible', 'success'])

const form = reactive({ name: '', description: '', status: 'NORMAL' })
const submitting = ref(false)

watch(() => props.visible, (val) => {
  if (val && props.asset) {
    form.name = props.asset.name || ''
    form.description = props.asset.description || ''
    form.status = props.asset.status || 'NORMAL'
  }
})

async function handleSubmit() {
  submitting.value = true
  try {
    await updateAsset(props.asset.id, {
      name: form.name,
      description: form.description || undefined,
      status: form.status,
      lockVersion: props.asset.lockVersion
    })
    ElMessage.success('素材已更新')
    emit('success')
    emit('update:visible', false)
  } catch {
    // handled by interceptor
  } finally {
    submitting.value = false
  }
}
</script>
